import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-layout" }

export function render(_ctx, _cache) {
  const _component_AppHeader = _resolveComponent("AppHeader")
  const _component_SideMenu = _resolveComponent("SideMenu")
  const _component_AppFooter = _resolveComponent("AppFooter")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppHeader),
    _createElementVNode("main", null, [
      _createVNode(_component_SideMenu),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createVNode(_component_AppFooter)
  ]))
}